import { postBody, useSpedQuery } from 'utils/ApiUtils'

export const loginUser = async ({
  username = '',
  password = ''
}) => {
  console.log('loginUser-> ', username);
  const url = new URL('auth/loginuser', window.location.href);
  const body = { username, password };
  try {
    const {data} = await postBody({ url, body });
    console.log('login.loginUser: ', data?.status);
    return data?.status === true;
  } catch (err) {
    console.error('loginUser error:', err);
    return false; // or throw err if you want caller to handle
  }
};

export const logoutUser = async (
  username = '',
  password = ''
) => {
  const url = new URL('auth/logoutuser', window.location.href);
  const body = {username, password};
  try {
    const {data} = await postBody({ url, body });
    return data?.status === true;
  } catch (err) {
    console.error('logoutUser error:', err);
    return false; // or throw err if you want caller to handle
  }
};

export const useIsLoggedInUser = ({
  enabled = true,
  refetchInterval = false
}) => {
  const url = new URL('auth/isloggedin', window.location.href);
  const res = useSpedQuery({
    queryName: 'loggedInUser',
    queryKeys: null,
    url: url,
    queryOptions: {
      enabled: enabled,
      refetchInterval: refetchInterval,
    }
  });
  return res;
};
